import { AxiosResponse } from "axios";
import { taxGuruAxios } from "../backend/taxguru/axios";
import { coreAttachmentUrls } from "../backend/taxguru/url";

export function resolveContentType(file: File) {
    if (/\.jpe?g/g.test(file.name)) {
        return "application/jpeg";
    } else if (file.name.endsWith(".png")) {
        return "application/png";
    } else if (file.name.endsWith(".isdoc") || file.name.endsWith(".ISDOC")) {
        return "text/xml";
    } else {
        return "application/pdf";
    }
}

export const parseFileNameFromContentDisposition = (response: AxiosResponse<unknown>) => {
    const contentDispositionHeader = response.headers["content-disposition"];
    if (!contentDispositionHeader) {
        return undefined;
    }
    const match = contentDispositionHeader.match(/filename\*=.*''(.+)/);
    if (match) {
        return decodeURI(match[1]);
    } else {
        const matchByName = contentDispositionHeader.match(/name="(.*)"/);
        return matchByName ? decodeURI(matchByName[1]) : undefined;
    }
};
export const downloadAttachmentToDisk = async (attachmentId: string) => {
    return downloadDataRelativeUrl(coreAttachmentUrls.download(encodeURIComponent(attachmentId)));
};

/**
 * For example download by clicking on notification URL like /api/tax/item/download
 */
export const downloadDataRelativeUrl = async (url: string) => {
    return new Promise<void>((resolve, reject) => {
        const finalUri = taxGuruAxios.getUri({ url });
        const a = document.createElement("a");
        a.href = finalUri;
        a.download = "attachment";
        try {
            a.click();
            a.remove();
            resolve();
        } catch (e) {
            reject(e);
        }
    });
};
